import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './TextArea.module.css';

// https://www.figma.com/file/hTeMNwZft7zNxdUwanR3ss/%E2%9D%96-Web-Component-Library?node-id=16%3A673
const TextArea = ({
  value = '',
  onChange = null,
  hasError = false,
  hasFocus = false,
  ...props
}) => {
  const [fieldValue, setFieldValue] = useState(value);

  const handleChange = event => {
    setFieldValue(event.target.value);

    if (onChange) {
      onChange(event);
    }
  };

  useEffect(
    () => {
      setFieldValue(value);
    },
    [value]
  );

  return (
    <textarea
      styleName={classNames('textarea', {
        error: hasError,
        focus: hasFocus
      })}
      value={fieldValue}
      onBlur={handleChange}
      onChange={handleChange}
      {...props}
    />
  );
};

TextArea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  hasError: PropTypes.bool,
  hasFocus: PropTypes.bool // trigger focus / hover styles manually
};

export default TextArea;
